import { useEffect, useState } from "react";
import { motion, useMotionValue } from "framer-motion";

const BITMAP = [
  "X...........",
  "XX..........",
  "XOX.........",
  "XOOX........",
  "XOOOX.......",
  "XOOOOX......",
  "XOOOOOX.....",
  "XOOOOOOX....",
  "XOOOOOOOX...",
  "XOOOOOXXXXX.",
  "XOOXOOX.....",
  "XOX.XOOX....",
  "XX...XOOX...",
  ".....XOOX...",
  ".....XOOX...",
  "......XX....",
];
const PX = 2.2;

export default function CustomCursor() {
  const [enabled, setEnabled] = useState(false);
  const [down, setDown] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const press = () => setDown(true);
    const release = () => setDown(false);
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mousedown", press);
    window.addEventListener("mouseup", release);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mousedown", press);
      window.removeEventListener("mouseup", release);
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <motion.div
      data-testid="custom-cursor"
      style={{ x, y, willChange: "transform" }}
      className="pointer-events-none fixed left-0 top-0 z-[200]"
    >
      <motion.div
        animate={{ scale: down ? 0.82 : 1, rotate: down ? -6 : 0 }}
        transition={{ type: "spring", stiffness: 400, damping: 18 }}
        style={{ transformOrigin: "2px 2px", filter: "drop-shadow(2px 2px 0 rgba(0,0,0,0.45))" }}
      >
        <svg
          width={BITMAP[0].length * PX}
          height={BITMAP.length * PX}
          shapeRendering="crispEdges"
          aria-hidden
        >
          {BITMAP.flatMap((row, ry) =>
            row.split("").map((cell, rx) =>
              cell === "." ? null : (
                <rect
                  key={`${rx}-${ry}`}
                  x={rx * PX}
                  y={ry * PX}
                  width={PX}
                  height={PX}
                  fill={cell === "X" ? "#0D0D0D" : "#F7F5F0"}
                />
              )
            )
          )}
        </svg>
      </motion.div>
    </motion.div>
  );
}
